    <!-- Header -->
    <div
        class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'services.dialog.moreInfoEvents.title' | transloco }} {{ service?.name }}
            - {{ task?.task?.taskTypeName }} - {{ task?.task?.taskId }} - {{ task.where.addressName }}
        </div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>
    